import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { GridLinkList } from "./GridLinkList";
import { PlainLinkList } from "./PlainLinkList";
export var LinkListBlock = function(param) {
    var content = param.content, translations = param.translations;
    var groupType = content.groupType;
    if (groupType === "grid") {
        return /*#__PURE__*/ _jsx(GridLinkList, {
            content: content,
            translations: translations
        });
    }
    return /*#__PURE__*/ _jsx(PlainLinkList, {
        content: content,
        translations: translations
    });
};
